<div class="trends-container">
    <div class="trends-header">
        <div class="header-container">
            <div class="header-title">
                <mat-label class="d-flex">{{'data-analytics.trends' | translate}} &nbsp; <div
                        *ngIf="currentlevel==='factory'" [style.display]="currentlevel==='factory' ? '' : 'none'"
                        [popover]="chartPopOver" triggers="mouseenter:mouseleave" container="body" placement="bottom">
                        <img src="../../../assets/images/icn-info.svg" alt="">
                    </div>
                    <div *ngIf="currentlevel==='line'" [style.display]="currentlevel==='line' ? '' : 'none'"
                        [popover]="chartPopOver1" triggers="mouseenter:mouseleave" container="body" placement="bottom">
                        <img src="../../../assets/images/icn-info.svg" alt="">
                    </div>
                </mat-label>
            </div>
            <div class="header-toggle">
                <div class="toggle-box">
                    <div class="toggle-left" [class.cost-select]="selectedChartType === 'cost'">
                        <mat-label  (click)="toggleType('cost')"
                            (keydown.enter)="toggleType('cost')"
                            (keydown.space)="toggleType('cost')">{{'data-analytics.cost' | translate}}</mat-label>
                    </div>
                    <div class="toggle-right" [class.percent-select]="selectedChartType === 'percentage'">
                        <mat-label  (click)="toggleType('percentage')"
                            (keydown.enter)="toggleType('percentage')"
                            (keydown.space)="toggleType('percentage')">{{'data-analytics.percentage' | translate}}
                        </mat-label>
                    </div>
                </div>

            </div>
            <div class="header-pop">
                <mat-icon  (click)="closeDialog()" (keydown.enter)="closeDialog()"
                    (keydown.space)="closeDialog()">fullscreen_exit</mat-icon>
            </div>
        </div>
    </div>
    <div class="trendes-graph" [class.show-div]="selectedChartType === 'cost'">
        <div #barGraphDiv class="donut" id="barGraphDiv"></div>
    </div>
    <div class="trendes-graph" [class.show-div]="selectedChartType === 'percentage'">
        <div #lineGraphDiv class="donut" id="lineGraphDiv"></div>
    </div>
</div>
<ng-template #chartPopOver>

    <div class="mb-5"><strong class="mr-5">Cost - </strong> Daily/Monthly trend of Actual Consumption
        Cost and Zero based Waste Target Cost against Target Waste Cost at the Factory level</div>
    <div class="mb-15"><strong class="mr-5">Percentage - </strong> Daily/Monthly trend of Waste% against
        Target Waste % at the Factory level </div>
    <div class="tooltip-formula">
        <div class="tooltip-left">
            Waste % =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                actual consumption cost - zero based waste target cost

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                zero based waste target cost
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>
<ng-template #chartPopOver1>

    <div class="mb-5-chart"><strong class="mr-5-chart">Cost - </strong> Daily/Monthly trend of Actual Consumption Cost
        and Zero
        based Waste
        Target Cost against Target Waste Cost at the Line level</div>
    <div class="mb-15-chart"><strong class="mr-5-chart">Percentage - </strong> Daily/Monthly trend of Waste% against
        Target Waste
        % at the
        Line level </div>
    <div class="tooltip-formula-chart">
        <div class="tooltip-left-chart">
            Waste % =
        </div>
        <div class="tooltip-center-chart">
            <div class="tooltip-center-top-chart">
                actual consumption cost - zero based waste target cost

            </div>
            <hr class="tooltip-center-middle-chart">
            <div class="tooltip-center-bottom-chart">
                zero based waste target cost
            </div>

        </div>
        <div class="tooltip-right-chart">
            * 100
        </div>
    </div>

</ng-template>